'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var o, t, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(t = 0; t < s.length; t++)o = s[t], !(r.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var o, t, n = {}, s = Object.keys(e);
    for(t = 0; t < s.length; t++)o = s[t], r.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
const ColorSwatchesMore = renderWithRef('ColorSwatchesMore', null, (o, t)=>{
    var { children: n } = o;
    return jsx(RenderComp, {
        root: "span",
        classNames: [
            'swan-color-swatches-more'
        ],
        forwardedRef: t,
        props: _object_without_properties(o, [
            "children"
        ]),
        children: n
    });
});

export { ColorSwatchesMore };
